import { useState, useContext, useEffect } from "react";
import {
	Container,
	Group,
	Image,
	Button,
	NativeSelect,
	TextInput,
} from "@mantine/core";
import ExperienceContext from "./ExperienceContext";
import hotspotIcon from "../../static/svg/hotspot.svg";
function HostspotControls({ activePanoId, selectedObject, closeControls }) {
	const [navigateTo, setNavigateTo] = useState(selectedObject.link);
	const [name, setName] = useState(selectedObject.name);
	const { experience, changeHotspotName, changeHotpotLink, deleteHotspot } =
		useContext(ExperienceContext);
	useEffect(() => {
		setNavigateTo(selectedObject.link);
		setName(selectedObject.name);
	}, [selectedObject]);
	const NavigateChange = (event) => {
		changeHotpotLink(
			activePanoId,
			selectedObject.id,
			event.currentTarget.value
		);
		setNavigateTo(event.currentTarget.value);
	};
	const data = experience.reduce(
		(prevData, pano) => {
			if (pano.id !== activePanoId) {
				prevData.push({ value: pano.id, label: pano.name });
			}
			return prevData;
		},
		[{ value: null, label: "Select scene" }]
	);
	return (
		<Group
			style={{
				height: "96px",
				width: "340px",
				backgroundColor: "#040f1fcc",
				padding: "10px 20px 10px 20px",
				borderRadius: "5px",
			}}
		>
			<Container
				px={0}
				mx={0}
				style={{
					backgroundColor: "#00000099",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					width: "50px",
					height: "50px",
					borderRadius: "50px",
				}}
			>
				<Image src={hotspotIcon} width="25px" alt="Hotspot" />
			</Container>
			<Container px={0} mx={0} style={{ width: "230px" }}>
				<Group direction="column" spacing={10}>
					<TextInput
						label="Name:"
						size="xs"
						styles={{
							root: {
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								width: "100%",
								color: "#A4BAC6",
							},
							label: {
								paddingRight: "10px",
								fontSize: "14px",
								color: "#A4BAC6",
							},
							input: { backgroundColor: "#040F1F" },
						}}
						value={name}
						onChange={(event) => {
							setName(event.currentTarget.value);
							changeHotspotName(
								activePanoId,
								selectedObject.id,
								event.currentTarget.value
							);
						}}
					/>
					<Group
						direction="row"
						style={{
							justifyContent: "space-between",
							alignItems: "center",
							width: "100%",
						}}
					>
						<NativeSelect
							variant="filled"
							size="xs"
							styles={{
								input: { backgroundColor: "#040F1F" },
								root: {
									width: "60%",
									color: "#A4BAC6",
								},
							}}
							placeholder="Navigate to"
							value={navigateTo}
							data={data}
							onChange={NavigateChange}
						/>
						<Button
							variant="outline"
							size="xs"
							radius={"sm"}
							py={5}
							style={{
								fontWeight: "normal",
								fontSize: "14px",
								color: "#ffffff",
								backgroundColor: "#e03131",
								borderColor: "#e03131",
							}}
							onClick={() => {
								deleteHotspot(activePanoId, selectedObject.id);
								closeControls();
							}}
						>
							Delete
						</Button>
					</Group>
				</Group>
			</Container>
		</Group>
	);
}

export default HostspotControls;
